<template>
    <span v-if="count > 0" class="dotag-badge" :class="'dotag-badge-' + size">{{ count }}</span>
</template>

<script>
export default {
    name: 'DotagBadge',
    props: {
        count: {
            type: Number,
            required: true
        },
        size: {
            type: String,
            required: false,
            default: 'normal',
            validator: value => ['xs', 's', 'normal', 'lg', 'xl'].includes(value)
        }
    }
}
</script>

<style scoped>
.dotag-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: #E10613;
    color: #fff;
    font-weight: bold;
    line-height: 1;
    border-radius: 999px;
    white-space: nowrap;
}

.dotag-badge-xs {
    min-width: 14px;
    height: 14px;
    padding: 0 3px;
    font-size: 9px;
}

.dotag-badge-s {
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    font-size: 10px;
}

.dotag-badge-normal {
    min-width: 20px;
    height: 20px;
    padding: 0 5px;
    font-size: 12px;
}

.dotag-badge-lg {
    min-width: 24px;
    height: 24px;
    padding: 0 6px;
    font-size: 14px;
}

.dotag-badge-xl {
    min-width: 28px;
    height: 28px;
    padding: 0 7px;
    font-size: 16px;
}
</style>
